import { helpPanelAnywherePages } from '../../context/page-mapping';
import { t } from '../app-utils/translations';
import { isStudioPage } from '../app-utils/page-specific-utils';
import { eventBus } from '../app-utils/event-bus';
import { getChatConfig } from '../app-utils/chat-config-utils';

export const isHelpPanelAnywherePage = () => {
  const pageUrl = window.location.href;
  const currentLocale = getChatConfig().locale;
  const allowedLocales = [
    'en-us',
    'en-gb',
    'en-ie',
    'en-ca',
    'en-au',
    'en-nz',
    'en-sg',
    'fr-fr',
    'fr-ca',
    'fr-ch',
    'fr-be',
    'de-de',
    'de-at',
    'de-ch',
    'it-ch',
    'it-it',
    'nl-nl',
    'nl-be',
    'es-es',
    'es-us',
    'da-dk',
    'fi-fi',
    'nb-no',
    'sv-se',
  ];
  return !!(
    helpPanelAnywherePages.find(
      (ele) => pageUrl.includes(t(ele)) && allowedLocales.includes(currentLocale.toLocaleLowerCase()),
    ) && isStudioPage()
  );
};

export const sendEventToHelpAnywherePanel = (type, additionalInfo = {}) => {
  eventBus.dispatch('eventToHelpAnywherePanel', {
    origin: 'CA',
    type,
    additionalInfo,
  });
};
